import React from 'react'
import {store} from '../../redux/store';

function AuthBtn(props) {
  return (
    store.getState().authbtns.includes(props.button) ? props.children : null
  )
}

export default AuthBtn